import { BASE_API_URL, HttpClient, type ResponseTypeWithStatus } from '../../services/HttpClient';

import type { ApplyCompetitorsRequest, CreateCraftEmailThreadRequest, SendMessageRequest } from './types';

const BASE_URL = `${BASE_API_URL}/ai-craft-email-agent`;

export const craftEmailAgentApi = {
  createThread: async (
    request: CreateCraftEmailThreadRequest,
    signal?: AbortSignal
  ): Promise<ResponseTypeWithStatus<Response>> =>
    HttpClient.postWithRawResponse(`${BASE_URL}/threads`, request, { signal }),

  sendMessage: async (request: SendMessageRequest, signal?: AbortSignal): Promise<ResponseTypeWithStatus<Response>> =>
    HttpClient.postWithRawResponse(
      `${BASE_URL}/threads/${request.threadId}/messages`,
      { message: request.message },
      { signal }
    ),

  applyEmailPreview: async (threadId: string, content: string): Promise<void> =>
    HttpClient.post<void>(`${BASE_URL}/threads/${threadId}/message-previews/apply`, { content }),

  sendFeedback: async (threadId: string, messageId: string, liked: boolean): Promise<void> =>
    HttpClient.put<void>(`${BASE_URL}/threads/${threadId}/messages/${messageId}/feedback?liked=${liked}`, {}),

  applyCompetitors: async (
    request: ApplyCompetitorsRequest,
    signal?: AbortSignal
  ): Promise<ResponseTypeWithStatus<Response>> =>
    HttpClient.postWithRawResponse(
      `${BASE_URL}/threads/${request.threadId}/competitors/apply`,
      { competitors: request.competitors },
      { signal }
    ),
};
